<template>
  <!-- 第二步：申报项目基本信息 -->
  <div class="caseInfo">
    <el-dialog :visible.sync="imgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <el-dialog
        title="添加案例"
        :visible.sync="dialogVisible"
        width="60%"
        :before-close="handleClose"
    >
      <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="180px"
          class="demo-form"
      >
        <div class="">
          <el-form-item label="案例名称" prop="classicCaseName">
            <el-input placeholder="围绕应用场景深度数字化转型提炼成一句话，例如“XX（企业）应用XX技术推动XX（关键业务场景：产品设计、工艺设计、营销管理、售后服务、计划排程、生产管控、质量管理、设备管理、安全生产、能耗管理、采购管理、仓储物流、财务管理、人力资源、协同办公、决策支持）实现XX （成效）”。（50字以内）"
                      type="textarea" maxlength="50" show-word-limit :autosize="{ minRows: 2, maxRows: 3}" v-model="form.classicCaseName" style="width:100%"></el-input>
          </el-form-item>
        </div>
        <div class="">
          <el-form-item label="案例简述" prop="caseIntroduction">
            <el-input placeholder="对主要背景、转型目标、关键业务场景共性需求及问题、具体举措（解决方案）和取得成效做整体性简述。（250字以内）"
                      type="textarea" maxlength="250" show-word-limit :autosize="{ minRows: 2, maxRows: 6}" v-model="form.caseIntroduction" style="width:100%"></el-input>
          </el-form-item>
        </div>
        <div class="">
          <el-form-item label="案例背景" prop="caseBackground">
            <el-input placeholder="包括但不限于被服务企业的介绍、转型背景、转型痛点与需求" maxlength="500" show-word-limit
                      type="textarea" :autosize="{ minRows: 2, maxRows: 10}" v-model="form.caseBackground" style="width:100%"></el-input>
          </el-form-item>
        </div>
        <div class="">
          <el-form-item label="具体举措" prop="detailMeasure">
            <vue-editor
                useCustomImageHandler
                @image-added="handleImageAdded"
                :disabled="disabled"
                @text-change="handleChangeMeasure"
                placeholder="介绍企业针对所选关键业务场景进行数字化改造的具体举措（含场景改造使用了哪些数字化技术产品与解决方案，包含但不限于工业软件、工业互联网平台、智能装备等，改造的资金投入和实施周期等），需要附加该场景的实际图片，包含但不限于平台与软件系统截图、现场实际照片等。（2000字以内）"
                v-model="form.detailMeasure"
            ></vue-editor>
<!--            <el-input placeholder="介绍企业针对所选关键业务场景进行数字化改造的具体举措（含场景改造使用了哪些数字化技术产品与解决方案，包含但不限于工业软件、工业互联网平台、智能装备等，改造的资金投入和实施周期等），需要附加该场景的实际图片，包含但不限于平台与软件系统截图、现场实际照片等。（2000 字以内）"-->
<!--                      type="textarea" maxlength="2000" show-word-limit :autosize="{ minRows: 2, maxRows: 10}" v-model="form.detailMeasure" style="width:100%"></el-input>-->
          </el-form-item>
        </div>
        <div class="">
          <el-form-item label="技术创新" prop="technologyInnovation">
            <el-input placeholder="描述案例中人工智能、5G、区块链、云计算等新一代信息通信技术的应用情况，包含但不限于技术应用具体场景，技术应用方式方法等。（300 字以内）"
                      type="textarea" maxlength="300" show-word-limit :autosize="{ minRows: 2, maxRows: 6}" v-model="form.technologyInnovation" style="width:100%"></el-input>
          </el-form-item>
        </div>
        <div class="">
          <el-form-item label="应用成效" prop="applicationEffect">
            <el-input placeholder="分条提炼解决的具体问题和取得的具体成效，如在提质、降本、增效、绿色、安全等方面的情况。（500字以内）"
                      type="textarea" maxlength="500" show-word-limit :autosize="{ minRows: 2, maxRows: 10}" v-model="form.applicationEffect" style="width:100%"></el-input>
          </el-form-item>
        </div>
        <div class="">
          <el-form-item label="复制推广" prop="copyPropagation">
            <el-input placeholder="论述该场景案例在行业内中小企业的可复制推广性，如主要内容是否能反映细分行业中小企业共性需求、能解决共性问题，所用解决方案是否具有较高性价比、值得推广等。（300字以内）"
                      type="textarea" maxlength="300" show-word-limit :autosize="{ minRows: 2, maxRows: 10}" v-model="form.copyPropagation" style="width:100%"></el-input>
          </el-form-item>
        </div>

        <div class="flex">
          <el-form-item  label="场景图片" prop="attachNamePlan" style="width:100%">
            <el-upload
                class="avatar-uploader"
                action="/service-center/api/v1/upload/file/single"
                :file-list="fileList"
                list-type="picture-card"
                :headers="headers"
                :on-preview="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                accept=".jpg,.jpeg,.png, .JPG,.JPEG,.PBG,.GIF,.BMP"
                :on-remove="handleRemoveFile"
                :on-error="handleFileError"
                :on-success="handleFileSuccess">
              <i class="el-icon-plus"></i>
            </el-upload>
            <span class="red" v-if="fileList.length == 0">
              *未选择任何文件 注意：支持多张图片，格式：横图，16:9，png、jpg等图片格式，不超过2MB，清晰。
            </span>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')"
        >确 定</el-button
        >
      </span>
    </el-dialog>
    <div class="" style="font-size: 13px;margin-bottom: 10px">
      <span style="color: red;">*</span><span style="margin-left: 5px;">介绍本单位承建（或提供服务）的企业数字化转型典型案例，应选取最具代表性、取得相应荣誉的（其中业务类型为总包服务商的提供以总包形式进行服务的案例）。每个服务商提供不少于3个典型案例</span>
    </div>
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column
          v-for="(item, index) in headList"
          :key="index"
          :prop="item.value"
          :label="item.label"
          :width="item.width"
          :align="align"
      >
      </el-table-column>
      <el-table-column prop="indexCompany" label="操作" align="center" width="140" v-if="!disabled">
        <template slot-scope="scope">
          <div class="flex">
            <el-button v-if="!disabled"  type="primary" size="mini" @click="editIndex(scope.row, scope.$index)" :disabled="disabled">编辑</el-button>
            <el-button v-if="!disabled"  type="danger" size="mini" @click="deleteIndex(scope)" :disabled="disabled">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center;margin-top: 20px;">
      <el-button v-if="!disabled"  type="primary" @click="addIndex" size="mini" :disabled="disabled">新增</el-button>
      <!-- <el-button
        v-show="tableData.length > 1"
        type="danger"
        @click="deleteIndex"
        :disabled="disabled"
      >删除指标</el-button>-->
    </div>
  </div>
</template>

<script>
import {saveServiceProviderFourthInfo, getServiceProviderFourthInfo, single} from "../../utils/interface";
import {addProductConsult} from "../../utils/product";
/* 是否是正数 */
const straight = (rule, value, callback) => {
  // console.log(rule, value);
  if (!value) {
    callback(new Error(rule.message));
  }
  let reg = /^\d+(?=\.{0,1}\d+$|$)/;
  if (!reg.test(value)) {
    callback(new Error());
  }
  callback();
};
const form = () => {
  return {
    detailMeasure:'',
    attachNamePlan:'',
    profile:'',
    speciality:'',
    realName:'',
    title:'',
    education:'',
    major:'',
    attachPlan:[],
  };
};
const rules = () => {
  return {
    classicCaseName: [
      { required: true, message: "请输入案例名称", trigger: "blur" }
    ],
    caseBackground: [
      { required: true, message: "请输入案例背景", trigger: "blur" }
    ],
    detailMeasure: [
      { required: true, message: "请输入具体举措", trigger: "blur" }
    ],
    technologyInnovation: [
      { required: true, message: "请输入技术创新", trigger: "blur" }
    ],
    copyPropagation: [
      { required: true, message: "请输入复制推广", trigger: "blur" }
    ],
    caseIntroduction: [
      { required: true, message: "请输入案例简述", trigger: "change" }
    ],
    attachNamePlan: [
      { required: true, message: "请上传场景图片", trigger: "blur" }
    ],
    applicationEffect: [
      { required: true, message: "请输入应用成效", trigger: "blur" }
    ]
  };
};
export default {
  name: "",
  components: {},
  props: {
    uuid: String
  },
  data() {
    return {
      dialogImageUrl: '',
      imgDialogVisible: false,
      headList: [
        { label: "案例名称", value: "classicCaseName" },
        { label: "案例简述", value: "caseIntroduction" },
      ],
      align: {
        type: String,
        default: "center"
      },
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token") //	可以是授权凭证用的参数值
      },
      widthInput: 300,
      dialogVisible: false,
      form: form(),
      // 助理工程师、中级工程师、副高级工程师、正高级工程师
      sectorList: [{
        name: "无",
        value: "无"
      },{
        name: "助理工程师",
        value: "助理工程师"
      },
        {
          name: "中级工程师",
          value: "中级工程师"
        },{
          name: "副高级工程师",
          value: "副高级工程师"
        },{
          name: "正高级工程师",
          value: "正高级工程师"
        }],
      // 专科、本科、硕士、博士
      educationList: [{
        name: "专科",
        value: "专科"
      },
        {
          name: "本科",
          value: "本科"
        },{
          name: "硕士",
          value: "硕士"
        },{
          name: "博士",
          value: "博士"
        }],
      fileList: [],
      rules: rules(),
      indexForm: {
        cost: "", // 降低企业成本
        defective: "", // 降低不良品率
        efficient: "", // 提高生产运营效率
        utilization: "" // 提高能源利用率
      }, // 4个指标，至少填2个
      tableData: [],
      disabled: false,
      editIndexRow: -1, // 当前编辑行的索引
      uuid: "", // 本步骤的uuid
      showFile: false
    };
  },
  watch: {
    "form.buildDate"(val) {
      if (val) {
        this.form.startDate = val[0];
        this.form.endDate = val[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      // console.log(val, this.form)
    }
  },
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.uuid) {
      console.log('第两步')
      this.getServiceProviderFourthInfo(this.$route.query.uuid);
    }
  },
  methods: {
    handleChangeMeasure(delta, oldDelta, source){
      console.log('handleChangeMeasure', delta, oldDelta, source);
    },
    async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      // console.log('图片上传', );
      var formData = new FormData();
      formData.append("file", file); //第一个file 后台接收的参数名
      let res = await single(formData);
      // console.log('上传成功', res);
      if (res.url) {
        Editor.insertEmbed(cursorLocation, "image", res.url);
        resetUploader();
      } else {
        alert("上传返回失败");
      }
    },
    handleClose() {
      this.form=form();
      this.editIndexRow = -1; // 重置编辑行索引
      this.dialogVisible = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.fileList && this.fileList.length > 0){
            this.form.attachPlan = [];
            this.fileList.forEach(items => {
              this.form.attachPlan.push({
                path: items.url || items.path,
                name: items.name,
              });
            })
          }
          this.handleSubmitForm();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSubmitForm() {
      if (this.editIndexRow === -1) {
        // 新增模式
        this.tableData.push({ ...this.form });
      } else {
        // 编辑模式
        this.$set(this.tableData, this.editIndexRow, { ...this.form });
      }
      this.handleClose();
    },
    // 模板附件
    handleFileSuccess(res, file) {
      this.fileList.push(res);
      this.form.attachNamePlan = res.name;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    handleRemoveFile(file, fileList) {
      this.fileList = fileList;
    },

    handleFileError(err, file, fileList) {
      this.$message.error(err);
    },
    /* 新增指标 */
    addIndex() {
      // this.tableData.push({
      //   indexName: "",
      //   indexValue: "",
      //   indexCompany: ""
      // });
      this.form = form();
      this.fileList = [];
      this.editIndexRow = -1; // 重置编辑行索引
      this.dialogVisible = true;
    },
    // 新增编辑方法
    editIndex(row, index) {
      this.form = { ...row }; // 复制当前行数据到表单
      this.fileList = row.attachPlan?row.attachPlan.map(items => {
        return {
          ...items,
          url: items.path || items.url,
        }
      }) : [];
      this.editIndexRow = index; // 记录编辑行索引
      this.dialogVisible = true;
    },
    /* 删除指标 */
    deleteIndex(row) {
      // if (this.tableData.length == 1) {
      //   this.$message.warning("请至少保留一条指标！");
      //   return;
      // }
      this.$confirm("确认删除该条吗！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.tableData.splice(row.$index, 1);
      });
    },
    /* 获取第二步详情 */
    getServiceProviderFourthInfo(uuid) {
      getServiceProviderFourthInfo({unitUuid: uuid}).then(res => {
        if (res.success && res.data.length > 0) {
          this.form = res.data;
          this.form.buildDate = [this.form.startDate, this.form.endDate];
          this.disabled =
            this.$route.query.status == "1" ||
            this.$route.query.status == "4"
              ? false
              : true;
          this.tableData = res.data;
          // this.uuid = res.data.uuid;
          this.showFile = true;
        } else {
          this.form = form();
          this.indexForm = {
            cost: "",
            defective: "",
            efficient: "",
            utilization: ""
          };
          // this.tableData = [
          //   { indexName: "", indexValue: "", indexCompany: "" }
          // ];
        }
      });
    },
    /* 第二步保存 */
    save() {
      // console.log('第二步保存')
      const sum = this.tableData.length;
      // if (sum < 3) { todo
          if (sum < 3) {
            this.$message({
              message: "请填写不少于3个典型案例！",
              type: "warning"
            });
            return;
          }
          const list = this.tableData.map(item=>{
            return {
              ...item,
              unitUuid:this.$route.query.uuid || this.uuid,
            }
          });
          saveServiceProviderFourthInfo(list).then(res => {
            if (res.success) {
              this.$message({
                message: res.message,
                type: "success"
              });
              // this.uuid = res.data.uuid;
              this.$parent.activeStep++;
            } else {
              this.$message({
                message: res.message,
                type: "error"
              });
            }
          });
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      let isLt10M = file.size / 1024 / 1024 < 10;
      let fileNameLength = file.name.length <= 100;
      // this.fileName = file.name
      let fileName = file.name.lastIndexOf(".");
      const fileNameLen = file.name.length;
      const fileTypeName = file.name.substring(fileName, fileNameLen);
      if (!isLt10M) {
        this.$alert("文件大小不能超过10M", "提示", {
          confirmButtonText: "确定"
        });
      } else if (!fileNameLength) {
        this.$alert("文件名（包含后缀名）的最大长度不能超过100个字符", "提示", {
          confirmButtonText: "确定"
        });
      }
      return isLt10M && fileNameLength;
    },
    handleAvatarSuccess(res) {
      if (res) {
        this.form.file = res.url;
        this.form.fileName = res.fileName;
        this.showFile = false;
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success"
        });
        // console.log(this.form)
      }
    },
    removeFile() {
      this.form.file = "";
      this.form.fileName = "";
      console.log(this.form);
    },
    /* 下载文件 */
    downloadFile(url, name) {
      fetch(url).then(res => {
        res.blob().then(blob => {
          const blobUrl = window.URL.createObjectURL(blob);
          // 这里的文件名根据实际情况从响应头或者url里获取
          const filename = name;
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";

.caseInfo {
  min-height: 300px;
  margin-bottom: 35px;
  border-radius: 12px;

  .w350 {
    width: 350px;
  }

  .downFile {
    display: inline-flex;
    height: 40px;
    align-items: center;
    box-sizing: border-box;
    font-size: 14px;
    color: @basic-colors;
    cursor: pointer;
    text-decoration: underline;
  }

  .form-wrap {
    padding: 10px 20px;
    .bs();

    p {
      font-size: 14px;
      color: #888888;
      line-height: 1.7;
      margin-bottom: 40px;
    }

    .iploadInput {
      display: inline-flex;
      /deep/ .el-upload {
        align-self: start;
      }
    }

    .form-title {
      font-size: 14px;
      font-weight: bold;
      margin: 0 0 30px 0px;
      position: relative;
      color: #535353;

      &::before {
        position: absolute;
        content: "";
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #000;
        top: 50%;
        left: -8px;
        transform: translateY(-50%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/providerApply/caseInfo.vue